
// Returns the rect if the element is in the viewport, false if not.
// Accepts an extra offset for a larger virtual viewport.
// Triggers relayout.
export default function visibleRect(element, offset = window.innerHeight / 4, rect = element.getBoundingClientRect()) {
  return (rect.top <= window.innerHeight + offset && rect.top + element.offsetHeight + offset >= 0) ? rect : false;
}



// WEBPACK FOOTER //
// ./website/vendor/scripts/fabrique/modules/visible-rect.js